export default __webpack_public_path__ + "static/media/Rectangle223.a056d895.png";